<template>
  <div class="content">
    <!--列表-->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row type="flex" :gutter="20">
        <el-col :span="1" v-if="$utils.checkPer('car-special-offer.store')">
          <el-button
            style="float: left"
            type="primary"
            @click="addData"
            size="mini"
            >新增</el-button
          >
        </el-col>

        <el-col :span="3">
          <el-input
            v-model="where.name"
            style="width: 200px"
            placeholder="商品名称"
            clearable
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="index(where)" size="mini"
            >查询</el-button
          >
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-table
          v-loading="loading"
          border
          :data="tableData"
          height="650"
          style="margin-bottom: 5px"
        >
          <el-table-column
            type="index"
            fixed
            label="序号"
            width="50"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="name" label="商品名称" align="center">
          </el-table-column>
          <el-table-column prop="goods_num" align="center" label="商品库存">
          </el-table-column>
          <el-table-column prop="present_price" align="center" label="现价">
          </el-table-column>
          <el-table-column prop="original_price" align="center" label="原价">
          </el-table-column>
          <!-- status -->
          <el-table-column prop="created_at" align="center" label="状态">
            <template slot-scope="scope"
              >
              <el-tag v-if="scope.row.status == 2">已下架</el-tag>
              <el-tag type="success" v-if="scope.row.status == 1">在售</el-tag>
              <el-tag type="info" v-if="scope.row.status == 3">待审核</el-tag>
              <el-tag type="warning" v-if="scope.row.status == 4">驳回</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" align="center" label="时间">
            <template slot-scope="scope">{{
              $utils.isDate(scope.row.created_at)
            }}</template>
          </el-table-column>
          <el-table-column prop="address" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                v-if="$utils.checkPer('car-special-offer.store')"
                @click="editMessage(scope.row)"
                type="primary"
                plain
                >修改</el-button
              >
              <el-button
                size="small"
                v-if="$utils.checkPer('car-special-offer.store')"
                @click="delMessage(scope.row)"
                type="danger"
                plain
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="index(where)"
          :current-page.sync="where.page"
          :page-size="where.pagesize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </el-row>
    </div>
    <!-- 添加，编辑 -->
    <el-dialog
      title="商品列表"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      v-if="dialogVisible"
    >
      <shoppimgListFrom
        @emincarofer="onemincarofer"
        :row="updatedList"
        :edit="isupdata"
      ></shoppimgListFrom>
    </el-dialog>
  </div>
</template>

<script>
import {
  getcargoods,
  postcargoods,
  modifycargoods,
  delcargooods,
} from "../../api/api";

import shoppimgListFrom from "./fromShopping";
export default {
  components: { shoppimgListFrom },
  data() {
    return {
      tableData: [],
      keyword: [],
      loading: false,
      where: {
        name: "",
        page: 1,
        pagesize: 10,
      },
      total: 0,
      dialogVisible: false,
      isupdata: false,
      isupdataid: 0,
      updatedList: "",
    };
  },
  created() {
    this.getShoppingList();
  },
  methods: {
    // 得到商品列表
    async getShoppingList() {
      let { data } = await getcargoods(this.where);
      data = JSON.parse(data).data;
      this.total = data.total;
      this.tableData = data.data;
      console.log("商品列表数据", data.data);
    },
    addData() {
      this.dialogVisible = true;
    },
    //
    onemincarofer(obj) {
      if (obj.form) {
        if (this.isupdata == false) {
          postcargoods(obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
              this.getShoppingList();
            } else {
              this.$message.error(data.msg);
            }
          });
        }
        if (this.isupdata == true) {
          modifycargoods(this.isupdataid, obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
              this.getShoppingList();
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      }
      this.isupdata = false;
      this.isupdataid = 0;
      this.updatedList = "";
      this.dialogVisible = false;
    },
    editMessage(scope) {
      this.dialogVisible = true;
      this.isupdataid = scope.id;
      this.isupdata = true;
      this.updatedList = scope;
    },
    delMessage(scope) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delcargooods(scope.id).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.getShoppingList();
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.where.pagesize = val;
      this.getShoppingList();
    },
    index(e) {
      this.where = e;
      this.getShoppingList();
    },
    handleClose() {
      this.dialogVisible = false;
      this.getShoppingList();
    },
  },
};
</script>
<style lang="scss" scoped>
.el-col-3 {
  width: 210px;
}
.el-col-1 {
  width: 68px;
}
.el-breadcrumb {
  margin-bottom: 15px;
}
</style>